import { fade } from "@material-ui/core/styles/colorManipulator";
import { lighten } from "@material-ui/core/styles/colorManipulator";
export const styles = (theme) => ({
  tableCellInCollapes: {
    borderBottom: "none",
  },
  customInput: {
    border: "none",
  },
  customColumn: {
    paddingTop: "0.8rem",
    display: "flex",
    flexDirection: "column",
    paddingBottom: "0.8rem",
  },
  customerNameRow: {
    marginTop: "0.2rem",
    fontSize: "0.75rem",
    color: "#546e7a",
  },
  tableWrapper: {
    width: "100%",
    overflowX: "auto",
    minHeight: 300,
  },
  notiTable: {
    padding: "1.5rem",
    borderBottom: "solid 1px #dcdcdc",
  },
  tableContainer: {
    width: "100%",
  },
  frameTitle: {
    display: "flex",
    justifyContent: "space-between",
  },
  paperRoot: {
    // paddingTop: theme.spacing(2),
    // paddingBottom: theme.spacing(2),
    // paddingLeft: theme.spacing(2),
    // paddingRight: theme.spacing(2),
    marginTop: theme.spacing(3),
    // width: 'fit-content',
    width: "100%",
  },
  inputRoot: {
    color: "inherit",
    width: "100%",
  },
  iconEdit: {
    width: "16px",
    height: "16px",
    cursor: "pointer",
  },
  inputInputSearch: {
    paddingTop: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(10),
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: 200,
      "&:focus": {
        width: 250,
      },
    },
  },
  icon: {
    fontSize: 40,
    float: "right",
    cursor: "pointer",
  },
  iconWrap: {
    fontSize: 40,
    float: "right",
    cursor: "pointer",
    padding: "4px",
  },
  iconActive: {
    color: "#1fa82b",
  },
  expired_border: {
    borderRight: "5px solid #ff2121",
  },
  non_expired_border: {
    borderRight: "5px solid #1fa82b",
  },
  will_expired_border: {
    borderRight: "5px solid #ff9221",
  },
  imgVoucher: {
    width: "9vw",
    height: "6vw",
    objectFit: "contain",
    maxWidth: "100px",
  },
  formControl: {
    width: "100%",
  },
});
